// extracted by mini-css-extract-plugin
module.exports = {"fullscreen":"BBHTML_fullscreen__2f8ae","fullwindow":"BBHTML_fullwindow__1ak0D"};